import { ProjectLocalStorage } from "../storage/ProjectLocalStorage.js";
var _project;
var getSelectedProject = function(state) {
    return (_project = state.project) !== null && _project !== void 0 ? _project : null;
};
var getSelectedProjectId = function(state) {
    var ref;
    return ((ref = getSelectedProject(state)) === null || ref === void 0 ? void 0 : ref.id) || ProjectLocalStorage.getProjectId();
};
var isResourceTypeAssociated = function(state, resourceType) {
    var ref;
    var selectedProject = getSelectedProject(state);
    var ref1;
    var associatedResources = (ref1 = selectedProject === null || selectedProject === void 0 ? void 0 : (ref = selectedProject.resources) === null || ref === void 0 ? void 0 : ref[resourceType]) !== null && ref1 !== void 0 ? ref1 : [];
    return associatedResources.length > 0;
};
export var ProjectSelectors = {
    getSelectedProject: getSelectedProject,
    getSelectedProjectId: getSelectedProjectId,
    isResourceTypeAssociated: isResourceTypeAssociated
};

//# sourceMappingURL=ProjectSelectors.js.map